import { Separator } from '@/components/ui/separator';
import logo from '@/assets/logo.svg';
import { Button } from '@/components/ui/button';
import { useLocation } from 'react-router-dom';

const Footer = () => {
	const location = useLocation();
	return (
		<footer className="border-t border-gray-200">
			<div className="mx-auto w-full max-w-screen-xl px-2.5 lg:px-20 mb-6">
				{location.pathname === '/' && (
					<>
						<div className="flex flex-col !gap-4 mt-8">
							<div className="relative my-4 flex gap-3 overflow-hidden masked-overflow">
								<div className="text-5xl font-medium animate-marquee whitespace-nowrap">
									Create Quests <StarIcon /> Engage Users{' '}
									<StarIcon /> Grow Community
									<StarIcon />
								</div>
								<div className="absolute top-0 left-2 text-5xl font-medium animate-marquee2 whitespace-nowrap">
									Create Quests <StarIcon /> Engage Users{' '}
									<StarIcon /> Grow Community
									<StarIcon />
								</div>
							</div>
						</div>
						<Separator className="my-10" />
					</>
				)}
				<div className="my-10 ">
					<SignUpCTA />
				</div>
				<Separator className="my-10" />
				<FooterLinks />
				<Separator className="my-5" />
				<CopyWrite />
			</div>
		</footer>
	);
};

export default Footer;

const StarIcon = () => {
	return <span className="h3 mx-3 text-zinc-400">✦</span>;
};

const SignUpCTA = () => {
	return (
		<div className="flex flex-col lg:flex-row gap-6 lg:items-center  items-start justify-between">
			<div className="max-w-[340px] flex flex-col gap-3">
				<a href="/" className="w-fit">
					<picture className="undefined">
						<img
							src={logo}
							className="w-10 h-10 aspect-square object-center object-contain"
							loading="lazy"
							width={40}
							height={40}
							decoding="async"
						/>
					</picture>
				</a>
				<p className="text-muted-foreground text-sm">
					Supahub is a product feedback tool that helps you understand what
					your customers really want, and make better product decisions.
				</p>
			</div>
			<Button size="lg" className="rounded-xl text-lg h-12">
				Sign up for free
			</Button>
		</div>
	);
};

const CopyWrite = () => {
	return (
		<div className="flex flex-row gap-4 items-center justify-between text-black-500">
			<div className="flex  items-center gap-2">
				<div className="size-5 text-muted-foreground">
					<svg
						width="100%"
						height="100%"
						viewBox="0 0 24 24"
						fill="inherit"
						xmlns="http://www.w3.org/2000/svg"
						className="fill-current"
					>
						<path
							fillRule="evenodd"
							clipRule="evenodd"
							d="M11.8673 4H12.1327C12.8071 8.02 15.98 11.1928 20 11.8673V12.1327C15.98 12.8072 12.8071 15.98 12.1327 20H11.8673C11.1929 15.98 8.02001 12.8072 4 12.1327V11.8673C8.02001 11.1928 11.1929 8.02 11.8673 4Z"
						/>
					</svg>
					<span className="sr-only">Little Star</span>
				</div>
				<span className="text-sm text-muted-foreground">
					Copyright © 2024 Supahub. All rights reserved.
				</span>
			</div>
			<div className="inline-flex gap-2 items-center">
				<a
					href="https://twitter.com/supahub"
					target="_blank"
					className="btn-size-5 btn-tertiary"
				>
					<div className="size-5">
						<svg
							width="100%"
							height="100%"
							viewBox="0 0 24 24"
							fill="inherit"
							xmlns="http://www.w3.org/2000/svg"
							className="fill-current"
						>
							<path
								fillRule="evenodd"
								clipRule="evenodd"
								d="M21.55 22H15.75L10.4 14.2L3.7 22H2L9.65 13.1L2 2H7.8L12.85 9.35L19.2 2H20.9L13.65 10.45L21.55 22ZM19.2 20.75H16.55L4.35 3.3H7L19.2 20.75Z"
							/>
						</svg>
						<span className="sr-only">Twitter</span>
					</div>
					<span className="sr-only">Twitter</span>
				</a>
				<span className="smalltext-regular text-black-500">/</span>
				<a
					href="https://www.instagram.com/supahub_hq"
					target="_blank"
					className="btn-size-5 btn-tertiary"
				>
					<div className="size-5">
						<svg
							width="100%"
							height="100%"
							viewBox="0 0 24 24"
							fill="inherit"
							xmlns="http://www.w3.org/2000/svg"
							className="fill-current"
						>
							<path
								opacity="0.2"
								d="M16.5 3H7.5C6.30653 3 5.16193 3.47411 4.31802 4.31802C3.47411 5.16193 3 6.30653 3 7.5V16.5C3 17.6935 3.47411 18.8381 4.31802 19.682C5.16193 20.5259 6.30653 21 7.5 21H16.5C17.6935 21 18.8381 20.5259 19.682 19.682C20.5259 18.8381 21 17.6935 21 16.5V7.5C21 6.30653 20.5259 5.16193 19.682 4.31802C18.8381 3.47411 17.6935 3 16.5 3ZM12 15.75C11.2583 15.75 10.5333 15.5301 9.91661 15.118C9.29993 14.706 8.81928 14.1203 8.53545 13.4351C8.25162 12.7498 8.17736 11.9958 8.32205 11.2684C8.46675 10.541 8.8239 9.8728 9.34835 9.34835C9.8728 8.8239 10.541 8.46675 11.2684 8.32205C11.9958 8.17736 12.7498 8.25162 13.4351 8.53545C14.1203 8.81928 14.706 9.29993 15.118 9.91661C15.5301 10.5333 15.75 11.2583 15.75 12C15.75 12.9946 15.3549 13.9484 14.6517 14.6517C13.9484 15.3549 12.9946 15.75 12 15.75Z"
							/>
							<path d="M16.5 2.25H7.5C6.10807 2.25149 4.77358 2.80509 3.78933 3.78933C2.80509 4.77358 2.25149 6.10807 2.25 7.5V16.5C2.25149 17.8919 2.80509 19.2264 3.78933 20.2107C4.77358 21.1949 6.10807 21.7485 7.5 21.75H16.5C17.8919 21.7485 19.2264 21.1949 20.2107 20.2107C21.1949 19.2264 21.7485 17.8919 21.75 16.5V7.5C21.7485 6.10807 21.1949 4.77358 20.2107 3.78933C19.2264 2.80509 17.8919 2.25149 16.5 2.25ZM20.25 16.5C20.25 17.4946 19.8549 18.4484 19.1517 19.1517C18.4484 19.8549 17.4946 20.25 16.5 20.25H7.5C6.50544 20.25 5.55161 19.8549 4.84835 19.1517C4.14509 18.4484 3.75 17.4946 3.75 16.5V7.5C3.75 6.50544 4.14509 5.55161 4.84835 4.84835C5.55161 4.14509 6.50544 3.75 7.5 3.75H16.5C17.4946 3.75 18.4484 4.14509 19.1517 4.84835C19.8549 5.55161 20.25 6.50544 20.25 7.5V16.5ZM12 7.5C11.11 7.5 10.24 7.76392 9.49993 8.25839C8.75991 8.75285 8.18314 9.45566 7.84254 10.2779C7.50195 11.1002 7.41283 12.005 7.58647 12.8779C7.7601 13.7508 8.18868 14.5526 8.81802 15.182C9.44736 15.8113 10.2492 16.2399 11.1221 16.4135C11.995 16.5872 12.8998 16.4981 13.7221 16.1575C14.5443 15.8169 15.2471 15.2401 15.7416 14.5001C16.2361 13.76 16.5 12.89 16.5 12C16.4988 10.8069 16.0243 9.66303 15.1806 8.81939C14.337 7.97575 13.1931 7.50124 12 7.5ZM12 15C11.4067 15 10.8266 14.8241 10.3333 14.4944C9.83994 14.1648 9.45542 13.6962 9.22836 13.148C9.0013 12.5999 8.94189 11.9967 9.05764 11.4147C9.1734 10.8328 9.45912 10.2982 9.87868 9.87868C10.2982 9.45912 10.8328 9.1734 11.4147 9.05764C11.9967 8.94189 12.5999 9.0013 13.148 9.22836C13.6962 9.45542 14.1648 9.83994 14.4944 10.3333C14.8241 10.8266 15 11.4067 15 12C15 12.7956 14.6839 13.5587 14.1213 14.1213C13.5587 14.6839 12.7956 15 12 15ZM18 7.125C18 7.3475 17.934 7.56501 17.8104 7.75002C17.6868 7.93502 17.5111 8.07922 17.3055 8.16436C17.1 8.24951 16.8738 8.27179 16.6555 8.22838C16.4373 8.18498 16.2368 8.07783 16.0795 7.9205C15.9222 7.76316 15.815 7.56271 15.7716 7.34448C15.7282 7.12625 15.7505 6.90005 15.8356 6.69448C15.9208 6.48891 16.065 6.31321 16.25 6.1896C16.435 6.06598 16.6525 6 16.875 6C17.1734 6 17.4595 6.11853 17.6705 6.3295C17.8815 6.54048 18 6.82663 18 7.125Z" />
						</svg>
						<span className="sr-only">LinkedIn</span>
					</div>
					<span className="sr-only">Instagram</span>
				</a>
				<span className="smalltext-regular text-black-500">/</span>
				<a
					href="https://www.linkedin.com/company/supahub"
					target="_blank"
					className="btn-size-5 btn-tertiary"
				>
					<div className="size-5">
						<svg
							width="100%"
							height="100%"
							viewBox="0 0 24 24"
							fill="inherit"
							xmlns="http://www.w3.org/2000/svg"
							className="fill-current"
						>
							<path
								opacity="0.2"
								d="M21 3.75V20.25C21 20.4489 20.921 20.6397 20.7803 20.7803C20.6397 20.921 20.4489 21 20.25 21H3.75C3.55109 21 3.36032 20.921 3.21967 20.7803C3.07902 20.6397 3 20.4489 3 20.25V3.75C3 3.55109 3.07902 3.36032 3.21967 3.21967C3.36032 3.07902 3.55109 3 3.75 3H20.25C20.4489 3 20.6397 3.07902 20.7803 3.21967C20.921 3.36032 21 3.55109 21 3.75Z"
							/>
							<path d="M20.25 2.25H3.75C3.35218 2.25 2.97064 2.40804 2.68934 2.68934C2.40804 2.97064 2.25 3.35218 2.25 3.75V20.25C2.25 20.6478 2.40804 21.0294 2.68934 21.3107C2.97064 21.592 3.35218 21.75 3.75 21.75H20.25C20.6478 21.75 21.0294 21.592 21.3107 21.3107C21.592 21.0294 21.75 20.6478 21.75 20.25V3.75C21.75 3.35218 21.592 2.97064 21.3107 2.68934C21.0294 2.40804 20.6478 2.25 20.25 2.25ZM20.25 20.25H3.75V3.75H20.25V20.25ZM9 10.5V16.5C9 16.6989 8.92098 16.8897 8.78033 17.0303C8.63968 17.171 8.44891 17.25 8.25 17.25C8.05109 17.25 7.86032 17.171 7.71967 17.0303C7.57902 16.8897 7.5 16.6989 7.5 16.5V10.5C7.5 10.3011 7.57902 10.1103 7.71967 9.96967C7.86032 9.82902 8.05109 9.75 8.25 9.75C8.44891 9.75 8.63968 9.82902 8.78033 9.96967C8.92098 10.1103 9 10.3011 9 10.5ZM17.25 13.125V16.5C17.25 16.6989 17.171 16.8897 17.0303 17.0303C16.8897 17.171 16.6989 17.25 16.5 17.25C16.3011 17.25 16.1103 17.171 15.9697 17.0303C15.829 16.8897 15.75 16.6989 15.75 16.5V13.125C15.75 12.6277 15.5525 12.1508 15.2008 11.7992C14.8492 11.4475 14.3723 11.25 13.875 11.25C13.3777 11.25 12.9008 11.4475 12.5492 11.7992C12.1975 12.1508 12 12.6277 12 13.125V16.5C12 16.6989 11.921 16.8897 11.7803 17.0303C11.6397 17.171 11.4489 17.25 11.25 17.25C11.0511 17.25 10.8603 17.171 10.7197 17.0303C10.579 16.8897 10.5 16.6989 10.5 16.5V10.5C10.5009 10.3163 10.5693 10.1393 10.692 10.0026C10.8148 9.86596 10.9834 9.7791 11.166 9.75852C11.3485 9.73794 11.5323 9.78508 11.6824 9.89099C11.8325 9.99691 11.9385 10.1542 11.9803 10.3331C12.4877 9.98894 13.0792 9.78947 13.6914 9.75611C14.3036 9.72276 14.9133 9.85679 15.455 10.1438C15.9968 10.4308 16.4501 10.86 16.7664 11.3852C17.0826 11.9105 17.2498 12.5119 17.25 13.125ZM9.375 7.875C9.375 8.0975 9.30902 8.31501 9.1854 8.50002C9.06179 8.68502 8.88609 8.82922 8.68052 8.91436C8.47495 8.99951 8.24875 9.02179 8.03052 8.97838C7.81229 8.93498 7.61184 8.82783 7.4545 8.6705C7.29717 8.51316 7.19002 8.31271 7.14662 8.09448C7.10321 7.87625 7.12549 7.65005 7.21064 7.44448C7.29578 7.23891 7.43998 7.06321 7.62498 6.9396C7.80999 6.81598 8.0275 6.75 8.25 6.75C8.54837 6.75 8.83452 6.86853 9.0455 7.0795C9.25647 7.29048 9.375 7.57663 9.375 7.875Z" />
						</svg>
						<span className="sr-only">LinkedIn</span>
					</div>
					<span className="sr-only">LinkedIn</span>
				</a>
			</div>
		</div>
	);
};

const FooterLinks = () => {
	return (
		<div className="my-10">
			<div className="md:grid md:grid-cols-4">
				{footerLinks.map((group) => (
					<FooterLinksGroup {...group} />
				))}
			</div>
		</div>
	);
};

const FooterLinksGroup = ({ title, links }) => {
	return (
		<div>
			<h3 className="text-sm font-semibold text-gray-800">{title}</h3>
			<ul role="list" className="mt-4 space-y-4">
				{links.map((i) => (
					<li>
						<a
							className="text-sm text-gray-500 hover:text-gray-800"
							href={i.href}
						>
							{i.title}
						</a>
					</li>
				))}
			</ul>
		</div>
	);
};

const footerLinks = [
	{
		title: 'Features',
		links: [
			{
				title: 'Advanced Analytics',
				href: '/features/analytics',
			},
			{
				title: 'Branded Links',
				href: '/features/branded-links',
			},
			{
				title: 'QR Codes',
				href: '/features/qr-codes',
			},
		],
	},
	{
		title: 'Features',
		links: [
			{
				title: 'Advanced Analytics',
				href: '/features/analytics',
			},
			{
				title: 'Branded Links',
				href: '/features/branded-links',
			},
			{
				title: 'QR Codes',
				href: '/features/qr-codes',
			},
			{
				title: 'QR Codes',
				href: '/features/qr-codes',
			},
			{
				title: 'QR Codes',
				href: '/features/qr-codes',
			},
		],
	},
	{
		title: 'Features',
		links: [
			{
				title: 'Advanced Analytics',
				href: '/features/analytics',
			},
			{
				title: 'Branded Links',
				href: '/features/branded-links',
			},
			{
				title: 'QR Codes',
				href: '/features/qr-codes',
			},
		],
	},
	{
		title: 'Features',
		links: [
			{
				title: 'Advanced Analytics',
				href: '/features/analytics',
			},
			{
				title: 'Branded Links',
				href: '/features/branded-links',
			},
			{
				title: 'QR Codes',
				href: '/features/qr-codes',
			},
			{
				title: 'QR Codes',
				href: '/features/qr-codes',
			},
		],
	},
];
